import { useEffect } from 'react'
import { motion } from 'motion/react'
import { useNavigation } from '@/contexts/NavigationProvider'
import { useGame } from '@/contexts/GameProvider'
import { getLevel } from '@/game/levels'
import { GameButton } from '@/components/ui/GameButton'
import { PixelIcon } from '@/components/ui/PixelIcon'

export function GameOverScreen() {
  const { startLevel, go } = useNavigation()
  const { lastLevelIndex, lastRun } = useGame()
  const level = lastLevelIndex != null ? getLevel(lastLevelIndex) : undefined

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.key === 'Enter' || e.key === ' ' || e.key.toLowerCase() === 'r') && level) {
        e.preventDefault()
        startLevel(level.index)
      } else if (e.key === 'Escape') {
        go('map')
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [level, startLevel, go])

  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 px-6 text-center">
      <motion.div
        initial={{ scale: 0.7, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 240, damping: 20 }}
        className="grid place-items-center w-20 h-20 rounded-full bg-[var(--surface-raised)] shadow-emboss"
        style={{ color: 'var(--danger)' }}
      >
        <PixelIcon name="restart" size={36} />
      </motion.div>

      <div>
        <h1 className="font-display text-2xl font-black">Not quite home</h1>
        <p className="mt-1 text-[var(--text-dim)]">
          {level ? `${level.name} — ${lastRun?.slides ?? 0} slides used` : 'Give it another go.'}
        </p>
      </div>

      <div className="flex flex-col gap-2 w-full max-w-xs">
        {level && (
          <GameButton size="lg" icon="retry" fullWidth onClick={() => startLevel(level.index)}>
            Try Again
          </GameButton>
        )}
        <GameButton variant="ghost" icon="levelSelect" fullWidth onClick={() => go('map')}>
          Back to Map
        </GameButton>
      </div>
    </div>
  )
}
